module.exports = __webpack_public_path__ + "img/Q16b.6621163f.png";